module.exports = __webpack_public_path__ + "img/sa.6a6a776e.svg";